import { TpSlDragIntent } from './tp-sl-drag-intent';

/**
 * Flow A 드래그 중 진입가~드래그가 사이를 채우는 손익존 색상.
 *
 * 차트 shape(`createMultipointShape`)는 Panda CSS 토큰을 해석하지 못하고 raw 색 문자열만
 * 받으므로, 디자인 토큰 값을 여기 상수로 둔다. (ChartStyles는 charting_library 런타임에
 * 의존해 테스트 환경에서 로드가 어려워, 테스트 가능하도록 이 모듈로 분리한다.)
 */

/** 수익존(TP) 채움. design token: background.accent.buy.tint */
export const PROFIT_ZONE_FILL = 'rgba(52, 199, 89, 0.12)';
/** 손실존(SL) 채움. design token: background.accent.sell.tint */
export const LOSS_ZONE_FILL = 'rgba(255, 73, 63, 0.12)';

/** 드래그 방향(TP/SL)에 따른 손익존 채움 색을 고른다. */
export function tpSlZoneFillColor(kind: TpSlDragIntent['kind']): string {
  return kind === 'SL' ? LOSS_ZONE_FILL : PROFIT_ZONE_FILL;
}
